import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Hero from "../CommonComponent/Hero_SideBySide";
import Logos from "../CommonComponent/Logos";
import Info from "../CommonComponent/Info";
import Footer from "../CommonComponent/Footer";
import TestimonialV2 from "../CommonComponent/TestimonialV2";
import { continuousImprovementAction } from "../../redux/actions/continuousImprovementAction";
import CustomReports from "./CustomReports";
import Customization from "./Customization";
import { scroll } from "../../utils/scrollTop";
import { metaData } from "../../utils/metaData";
import DriveParticipation from "../CommonComponent/DriveParticipation";

const ContinuousImprovement = () => {
  const dispatch = useDispatch();
  const ContinuousimprovementData = useSelector(
    (state) => state?.continuousimprovementPage?.continuousimprovementPage?.acf
  );

  useEffect(() => {
    metaData("45927");
    scroll();
    dispatch(continuousImprovementAction());
  }, [dispatch]);

  const hero = ContinuousimprovementData?.hero_banner_v2;
  const {
    trusted_by_innovative_leaders: companyLogos,
    setup_and_result: { setup_and_result } = {},
    section_before_footer: info,
    custom_reports: Custom,
  } = ContinuousimprovementData || {};

  const text_before_title =
  ContinuousimprovementData?.setup_and_result?.text_before_title;
const title = ContinuousimprovementData?.setup_and_result?.title;
const drive1 = setup_and_result?.right_image_align_section;
const drive2 = setup_and_result?.left_image_align_section;
const drive3 = setup_and_result?.right_image_align_section_next;
const drive4 = setup_and_result?.left_image_align_section_next;

  return (
    <>
      {ContinuousimprovementData ? (
        <>
          <Hero data={hero}/>
          <Logos
            title={companyLogos?.text_before_title}
            unilever={companyLogos?.leaders_logo?.unilever}
            whirlpool={companyLogos?.leaders_logo?.whirlpool}
            mount={companyLogos?.leaders_logo?.mount_franklin_foods}
            moura={companyLogos?.leaders_logo?.moura}
          />
          <DriveParticipation
            text_before_title={text_before_title}
            title={title}
            card1={drive1}
            card2={drive2}
            card3={drive3}
            card4={drive4}
            removePonit={true}
          />
          {/* <Features /> */}
          <Customization />
          <CustomReports
            smalltitle={Custom?.text_before_title}
            title={Custom?.title}
            desc={Custom?.description}
            btn={Custom?.call_to_action_button?.title}
            btnlink={Custom?.call_to_action_button?.url}
            img={Custom?.image}
          />
          <TestimonialV2 data={ContinuousimprovementData?.testimonials_version_3} />
          <Info
            title={info?.title}
            desc={info?.description}
            btn={info?.call_to_action_button?.title}
          // btn2={info?.call_to_action_button_2?.title}
          />
          <Footer />
        </>
      ) : (
        []
      )}
    </>
  );
};

export default ContinuousImprovement;
